import React from "react";
import styles from "./header.module.scss";

const Header: React.FC = () => {
  return (
    <div className={styles.header}>
      <div className={styles.nameSection}>
        <h1 className={styles.name}>Maximilian Grätz</h1>
        <p className={styles.birthInfo}>
          * 02.02.1993 in Starnberg, Bavaria (DE)
        </p>
      </div>
      <div className={styles.quickContact}>
        <p className={styles.address}>Stadtplatz 30, 84453 Mühldorf a. Inn</p>
        <div className={styles.contactLinks}>
          <a href="tel:+4901785598780" className={styles.phone}>
            01785598780
          </a>
          <span className={styles.separator}>•</span>
          <a href="mailto:max@mgraetz.de" className={styles.email}>
            max@mgraetz.de
          </a>
        </div>
      </div>
    </div>
  );
};

export default Header;
